import React, { FC, PropsWithChildren } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../../../constants/aampeTheme';

// models
import { NotificationButtonElement } from '../../../../../models/formula.model';

// components

export interface TextContentProps {
    hasImage?: boolean;
    phonePreview?: boolean;
    isSkeleton?: boolean;
    isFirst?: boolean;
    isLast?: boolean;
}

interface MobilePushButtonPreviewProps {
    buttons: NotificationButtonElement[];
}
const MobilePushButtonPreview: FC<
    PropsWithChildren<MobilePushButtonPreviewProps>
> = ({ buttons }) => {
    return (
        <>
            {buttons.map((button, index) => (
                <>
                    <Message
                        key={index}
                        isFirst={index === 0}
                        isLast={index === buttons.length - 1}
                    >
                        {button.text}
                    </Message>
                    <div></div>
                </>
            ))}
        </>
    );
};

export default MobilePushButtonPreview;
const Message = styled.div.withConfig({
    shouldForwardProp: (prop) =>
        !['isFirst', 'isLast', 'isSkeleton'].includes(prop),
})<{
    isSkeleton?: boolean;
    isFirst?: boolean;
    isLast?: boolean;
}>(({ isSkeleton, isFirst, isLast }) => ({
    background:
        'linear-gradient(279deg, #F2F7FC 1.91%, #F9FBFE 16.23%, #FFF 39.11%)',
    boxShadow: '0px 4px 6px 2px rgba(13, 99, 184, 0.08)',
    borderRadius: `${isFirst ? aampeTheme.borderRadius.message : '0'}
                       ${isFirst ? aampeTheme.borderRadius.message : '0'}
                       ${isLast ? aampeTheme.borderRadius.message : '0'}
                       ${isLast ? aampeTheme.borderRadius.message : '0'}`,
    border: `1px solid ${aampeTheme.colors.white}`,
    padding: aampeTheme.spacing4(4),
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    fontSize: aampeTheme.size.font.textSmall,
    alignItems: 'center',
    width: '100%',
    height: isFirst ? '36px' : isLast ? '34px' : '30px',
    whiteSpace: 'pre-wrap',
    minHeight: isSkeleton ? '140px' : 'none',
}));
